import React from 'react';
import { Box, RadioPill, RadioPillGroup, TextHeadingTwo, Text } from '@cko/primitives';
import { Themes } from '@cko/dashboard-shared';
import { useThemes } from '../../../../../providers';
import { useDeveloperToolsProvider } from '../../../../context';

export const UserPreferencesPanel = () => {
  const { overrides, setOverrides } = useDeveloperToolsProvider(); //showOverridesOnly
  const { theme } = useThemes();
  const currentTheme: Themes = overrides.userPreferences.theme || theme;
  const radios = [
    currentTheme === 'system-default',
    currentTheme === 'light',
    currentTheme === 'dark',
  ];

  const handleChange = (newTheme: Themes) => {
    setOverrides({
      ...overrides,
      userPreferences: { ...overrides.userPreferences, theme: newTheme },
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--layout-soybean)' }}>
      <TextHeadingTwo>Current Permissions</TextHeadingTwo>
      <Box
        style={{
          display: 'grid',
          gridTemplateColumns: '300px 50px 50px',
          gap: '4px',
          alignItems: 'center',
        }}
      >
        <RadioPillGroup label={'Theme'} isRequired helpText="">
          <RadioPill
            checked={radios[0]}
            onChange={() => handleChange('system-default')}
            label="System Default"
          />
          <RadioPill checked={radios[1]} onChange={() => handleChange('light')} label="Light" />
          <RadioPill checked={radios[2]} onChange={() => handleChange('dark')} label="Dark" />
        </RadioPillGroup>
      </Box>
      <Text>If you change the system default, please refresh the page to see it applied.</Text>
    </div>
  );
};
